module.exports = __webpack_public_path__ + "static/img/sequence-0.fbe80c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/sequence-0.jpg
// module id = Niii
// module chunks = 0